var React = require('react');

function Tidal (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.59998 5.68726L2.3999 8.84338L5.59998 11.9995L8.80005 8.84338L5.59998 5.68726ZM8.79935 8.84422L11.9994 5.6881L15.1995 8.84422L11.9994 12.0003L8.79935 8.84422ZM8.79946 15.1567L11.9995 12.0006L15.1996 15.1567L11.9995 18.3129L8.79946 15.1567ZM15.1998 8.84411L18.3998 5.68799L21.5999 8.84411L18.3998 12.0002L15.1998 8.84411Z","fill":"#1C232B"}));
}

Tidal.displayName = "Tidal";

Tidal.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Tidal;

Tidal.default = Tidal;
